<template>
	<div
		class="c-global-search-hero-wrapper"
		:class="{'c-global-search-hero-wrapper--with-autosuggest': flag === 'heroBA'}"
	>
		<GlobalSearchField
			ref="searchField"
			:placeholder="vm.CurrentBlock.SearchBarPlaceholder"
			:autofocus="false"
			:flag="flag"
			@search="executeFacetSearch"
			@autosuggestsearch="autoSuggestSearch"
			@reset="cancelAutosuggestionSearch"
		/>

		<GlobalSearchAutoSuggestDropDownList
			v-if="flag === 'heroBA'"
			v-show="localSearchPhrase.length"
			:isLoading="autoSuggestInProgress"
			:noSearchResultsHeadline="vm.BaseViewModel?.NoSearchResultsHeadline"
			:noSearchResultsText="vm.BaseViewModel?.NoSearchResultsText"
			:didYouMeanText="vm.BaseViewModel?.DidYouMeanText"
		/>
	</div>
</template>

<script>
import GlobalSearchField from 'shared/components/globalSearch/globalSearchField.vue';
import GlobalSearchAutoSuggestDropDownList from 'shared/components/globalSearch/globalSearchAutosuggestDropDownList.vue';
import globalSearchAutosuggestResultsMixin from 'shared/mixins/globalSearchAutosuggestResultsMixin.js';
import { mapGetters, mapMutations } from 'vuex';
import * as _ from 'lodash';

export default {
	name: 'GlobalSearchFieldWrapper',

	components: {
		GlobalSearchField,
		GlobalSearchAutoSuggestDropDownList
	},

	mixins: [globalSearchAutosuggestResultsMixin],

	props: {
		vm: {
			type: Object,
			default: () => {},
		},
		flag: {
			type: String,
			default: 'heroBA',
		}
	},

	created() {
		if (!_.isEmpty(this.vm)) {
			const model = {
				...this.vm.BaseViewModel,
				AutoSuggestionMinimumCharacters:
				this.vm.BaseViewModel.MinimumCharactersToActivateAutoSuggest
			};

			this.setGlobalSearchModel(model);
		}
	},

	computed: {
		...mapGetters({
			autoSuggestInProgress: 'getAutoSuggestInProgress'
		})
	},

	methods: {
		...mapMutations([
			'setGlobalSearchModel'
		]),

		executeFacetSearch() {
			this.executeSearch(this.vm.CurrentBlock.BusinessAreaPresetFilter);
		}
	}
};
</script>

<style lang="scss" scoped>
.c-global-search-hero-wrapper {
	position: relative;

	&--with-autosuggest {
		:deep(.c-global-search-autosuggestions__box) {
			position: absolute;
			z-index: 1;
			max-width: 100%;
			width: 100%;
			margin: 0;
		}
	}
}
</style>
